import '@scss/main.scss';
import '@/components/splide.js';
import '@/components/file-upload.js';

// Component loader

const componentLoaders = {
    navigation: () => import('@/layout/navigation/index.js'),
    footer: () => import('@/layout/footer-menu.js'),
    newsletter: () => import('@/layout/newsletter.js'),
    accordion: () => import('@/components/accordion.js'),
    tabs: () => import('@/components/tabs.js'),
    video: () => import('@/components/video.js'),
    'discount-offer': () => import('@/components/discount-offer.js'),
}

// Component registry

const componentInitialisers = {
    navigation: 'initNavigation',
    footer: 'initFooterMenu',
    newsletter: 'initNewsletter',
    accordion: 'initAccordion',
    tabs: 'initTabs',
    video: 'initVideoPlayBtn',
    'discount-offer': 'initDiscountOffer',
};

// Auto loader & lazy loading for components based on data-component attribute

document.addEventListener('DOMContentLoaded', async() => {
    const elements = document.querySelectorAll('[data-component]');
    const grouped = new Map();

    elements.forEach((element) => {
        const name = element.dataset.component;
        if (!grouped.has(name)) {
            grouped.set(name, []);
        }
        grouped.get(name).push(element);
    });

    for (const [name, roots] of grouped.entries()) {
        const loadComponent = componentLoaders[name];
        const initName = componentInitialisers[name];

        if (!loadComponent || !initName) continue;

        try {
            const module = await loadComponent();
            const init = module[initName];

            if (typeof init !== 'function') continue;
            roots.forEach(root => init(root));

        } catch (error) {
            console.error(`Error loading component "${name}":`, error);
        }
    }
});